export const UI_LOCALE_STORAGE_KEY = "dashboard_locale";
export const SUPPORTED_UI_LOCALES = ["en", "es", "fr", "ar"];
export const FALLBACK_UI_LOCALE = "en";
export const API_LANGUAGE_BY_UI_LOCALE = {
  en: "en",
  es: "es",
  fr: "fr",
  ar: "ar",
};
export const FALLBACK_API_LANGUAGE = API_LANGUAGE_BY_UI_LOCALE.en;

export const RTL_LOCALES = ["ar"];
export const isRtlLocale = (locale) => RTL_LOCALES.includes(locale);

export const SUPPORTED_UI_LOCALE_OPTIONS = [
  { code: "en", labelKey: "locales.english", nativeLabel: "English" },
  { code: "es", labelKey: "locales.spanishLatam", nativeLabel: "Español" },
  { code: "fr", labelKey: "locales.french", nativeLabel: "Français" },
  { code: "ar", labelKey: "locales.arabic", nativeLabel: "العربية" },
];

export const normalizeLocale = (locale) => {
  if (!locale || typeof locale !== "string") {
    return FALLBACK_UI_LOCALE;
  }

  const normalized = locale.trim().toLowerCase();

  if (normalized.startsWith("es")) return "es";
  if (normalized.startsWith("fr")) return "fr";
  if (normalized.startsWith("ar")) return "ar";
  if (normalized === "en") return "en";

  return FALLBACK_UI_LOCALE;
};

export const mapUiLocaleToApiLanguage = (locale) => {
  const normalizedLocale = normalizeLocale(locale);
  return API_LANGUAGE_BY_UI_LOCALE[normalizedLocale] || FALLBACK_API_LANGUAGE;
};

const readStoredLocale = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.localStorage.getItem(UI_LOCALE_STORAGE_KEY);
  } catch {
    return null;
  }
};

const detectBrowserLocale = () => {
  if (typeof navigator === "undefined") {
    return FALLBACK_UI_LOCALE;
  }

  const candidate = navigator.languages?.[0] || navigator.language;
  return normalizeLocale(candidate);
};

export const detectInitialLocale = () => {
  const storedLocale = readStoredLocale();
  if (storedLocale) {
    return normalizeLocale(storedLocale);
  }

  return detectBrowserLocale();
};

export const persistLocale = (locale) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(UI_LOCALE_STORAGE_KEY, normalizeLocale(locale));
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
};
